<template>
  <textarea
    :class="`${
      isEditable ? '' : 'cursor-auto'
    }  w-full border px-3 py-2 resize-none font-mono text-sm focus:outline-none`"
    :disabled="!isEditable"
    :value="value"
    wrap="off"
    @input="changeText"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    isEditable: {
      type: Boolean,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    onChange: {
      type: Function,
      required: false
    }
  },
  setup(props) {
    const changeText = (e: Event) => {
      const target = e.target as HTMLTextAreaElement
      if (props.onChange) {
        props.onChange(target.value)
      }
    }

    return {
      changeText
    }
  }
})
</script>

<style></style>
